import { POST } from '@/api'
import { keyBy } from 'lodash'
import edit from './edit'

export default {
  namespaced: true,
  state: {
    byId: {},
    allIds: [],
    busy: false,
  },
  modules: {
    edit,
  },
  mutations: {
    set(state, courses) {
      state.byId = keyBy(courses, 'id')
      state.allIds = courses.map(course => course.id)
    },
    busy(state, busy) {
      state.busy = busy
    },
  },
  getters: {
    all: state => state.allIds.map(id => state.byId[id]).sort(),
    useReceptionIds: ({ allIds, byId }) => allIds.filter(id => byId[id].useReception).sort(),
  },
  actions: {
    async get(store) {
      const { commit } = store
      commit('busy', true)

      const { status, message, data } = await POST('/api/web/v2/course/list')
      if (status === 200) {
        commit('set', data.courseList)
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
    async delete(store, id) {
      const { commit, state } = store
      if (state.busy) return false
      commit('busy', true)

      const { status, message } = await POST('/api/web/v2/course/delete', { id })
      if (status !== 200) {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
    async saveOrder(store, courseIds) {
      const { commit, state } = store
      if (state.busy) return false
      commit('busy', true)

      const { status, message } = await POST('/api/web/v2/course/order', { courseIds })
      if (status !== 200) {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
